// extracted by mini-css-extract-plugin
export default {"wrapBtn":"Bill_wrapBtn__FjaIg","btn":"Bill_btn__sYMbu"};